module.exports = __webpack_public_path__ + "b4c9831deff12966bebef73e7cbed656.fbx";